type State = {
  abbr: string;
  name: string;
  isTerritory?: boolean;
}

export const usaStateList: Array<State> = [
  {
    abbr: 'AL',
    name: 'Alabama',
    isTerritory: false
  },
  {
    abbr: 'AK',
    name: 'Alaska',
    isTerritory: false
  },
  {
    abbr: 'AS',
    name: 'American Samoa',
    isTerritory: true
  },
  {
    abbr: 'AZ',
    name: 'Arizona',
    isTerritory: false
  },
  {
    abbr: 'AR',
    name: 'Arkansas',
    isTerritory: false
  },
  {
    abbr: 'CA',
    name: 'California',
    isTerritory: false
  },
  {
    abbr: 'CO',
    name: 'Colorado',
    isTerritory: false
  },
  {
    abbr: 'CT',
    name: 'Connecticut',
    isTerritory: false
  },
  {
    abbr: 'DE',
    name: 'Delaware',
    isTerritory: false
  },
  {
    abbr: 'DC',
    name: 'District of Columbia',
    isTerritory: false
  },
  {
    abbr: 'FL',
    name: 'Florida',
    isTerritory: false
  },
  {
    abbr: 'GA',
    name: 'Georgia',
    isTerritory: false
  },
  {
    abbr: 'GU',
    name: 'Guam',
    isTerritory: true
  },
  {
    abbr: 'HI',
    name: 'Hawaii',
    isTerritory: false
  },
  {
    abbr: 'ID',
    name: 'Idaho',
    isTerritory: false
  },
  {
    abbr: 'IL',
    name: 'Illinois',
    isTerritory: false
  },
  {
    abbr: 'IN',
    name: 'Indiana',
    isTerritory: false
  },
  {
    abbr: 'IA',
    name: 'Iowa',
    isTerritory: false
  },
  {
    abbr: 'KS',
    name: 'Kansas',
    isTerritory: false
  },
  {
    abbr: 'KY',
    name: 'Kentucky',
    isTerritory: false
  },
  {
    abbr: 'LA',
    name: 'Louisiana',
    isTerritory: false
  },
  {
    abbr: 'ME',
    name: 'Maine',
    isTerritory: false
  },
  {
    abbr: 'MD',
    name: 'Maryland',
    isTerritory: false
  },
  {
    abbr: 'MA',
    name: 'Massachusetts',
    isTerritory: false
  },
  {
    abbr: 'MI',
    name: 'Michigan',
    isTerritory: false
  },
  {
    abbr: 'MN',
    name: 'Minnesota',
    isTerritory: false
  },
  {
    abbr: 'MS',
    name: 'Mississippi',
    isTerritory: false
  },
  {
    abbr: 'MO',
    name: 'Missouri',
    isTerritory: false
  },
  {
    abbr: 'MT',
    name: 'Montana',
    isTerritory: false
  },
  {
    abbr: 'NE',
    name: 'Nebraska',
    isTerritory: false
  },
  {
    abbr: 'NV',
    name: 'Nevada',
    isTerritory: false
  },
  {
    abbr: 'NH',
    name: 'New Hampshire',
    isTerritory: false
  },
  {
    abbr: 'NJ',
    name: 'New Jersey',
    isTerritory: false
  },
  {
    abbr: 'NM',
    name: 'New Mexico',
    isTerritory: false
  },
  {
    abbr: 'NY',
    name: 'New York',
    isTerritory: false
  },
  {
    abbr: 'NC',
    name: 'North Carolina',
    isTerritory: false
  },
  {
    abbr: 'ND',
    name: 'North Dakota',
    isTerritory: false
  },
  {
    abbr: 'MP',
    name: 'Northern Mariana Islands',
    isTerritory: true
  },
  {
    abbr: 'OH',
    name: 'Ohio',
    isTerritory: false
  },
  {
    abbr: 'OK',
    name: 'Oklahoma',
    isTerritory: false
  },
  {
    abbr: 'OR',
    name: 'Oregon',
    isTerritory: false
  },
  {
    abbr: 'PA',
    name: 'Pennsylvania',
    isTerritory: false
  },
  {
    abbr: 'PR',
    name: 'Puerto Rico',
    isTerritory: true
  },
  {
    abbr: 'RI',
    name: 'Rhode Island',
    isTerritory: false
  },
  {
    abbr: 'SC',
    name: 'South Carolina',
    isTerritory: false
  },
  {
    abbr: 'SD',
    name: 'South Dakota',
    isTerritory: false
  },
  {
    abbr: 'TN',
    name: 'Tennessee',
    isTerritory: false
  },
  {
    abbr: 'TX',
    name: 'Texas',
    isTerritory: false
  },
  {
    abbr: 'UT',
    name: 'Utah',
    isTerritory: false
  },
  {
    abbr: 'VT',
    name: 'Vermont',
    isTerritory: false
  },
  {
    abbr: 'VI',
    name: 'Virgin Islands',
    isTerritory: true
  },
  {
    abbr: 'VA',
    name: 'Virginia',
    isTerritory: false
  },
  {
    abbr: 'WA',
    name: 'Washington',
    isTerritory: false
  },
  {
    abbr: 'WV',
    name: 'West Virginia',
    isTerritory: false
  },
  {
    abbr: 'WI',
    name: 'Wisconsin',
    isTerritory: false
  },
  {
    abbr: 'WY',
    name: 'Wyoming',
    isTerritory: false
  },
];

export const usaArmedForces: Array<State> = [
  {
    abbr: 'AE',
    name: 'Africa',
  },
  {
    abbr: 'AE',
    name: 'Canada',
  },
  {
    abbr: 'AE',
    name: 'Europe',
  },
  {
    abbr: 'AE',
    name: 'Middle East',
  },
  {
    abbr: 'AP',
    name: 'Pacific',
  },
];

export const canadaProvinceList: Array<State> = [
  {
    abbr: 'AB',
    name: 'Alberta'
  },
  {
    abbr: 'BC',
    name: 'British Columbia'
  },
  {
    abbr: 'MB',
    name: 'Manitoba'
  },
  {
    abbr: 'NB',
    name: 'New Brunswick'
  },
  {
    abbr: 'NL',
    name: 'Newfoundland and Labrador'
  },
  {
    abbr: 'NS',
    name: 'Nova Scotia'
  },
  {
    abbr: 'NT',
    name: 'Northwest Territories'
  },
  {
    abbr: 'NU',
    name: 'Nunavut'
  },
  {
    abbr: 'ON',
    name: 'Ontario'
  },
  {
    abbr: 'PE',
    name: 'Prince Edward Island'
  },
  {
    abbr: 'QB',
    name: 'Quebec'
  },
  {
    abbr: 'SK',
    name: 'Saskatchewan'
  },
  {
    abbr: 'YT',
    name: 'Yukon'
  },
];

/*
  TDC trait data for populating trait dropdowns and fieldsets
 */
export const learnMore = [
  { label:'Single Game Tickets', value:'single' },
  { label:'Ticket Packs (8-game packs or 14-game flex pack)', value:'flex' },
  { label:'Group Tickets (15 or more tickets for one game)', value:'group' },
  { label:'Full-season and multigame suite packages', value:'fullseason-multigame-suite' },
  { label:'Season tickets with premier club access', value:'season-premier-club' },
  { label:'Single game suite rental', value:'single-suite' },
  { label:'Premier group space rental', value:'premier-group' },
  { label:'Wrigley Rooftops', value:'rooftop' },
  { label:'Spring Training season tickets', value:'spring-training-season' },
  { label:'Spring Training single game tickets', value:'spring-training-single' },
  { label:`I'm not interested in learning more about Cubs ticket offers`, value:'nopurchase' },
];
